import * as Yup from "yup";

export const nationalCenterSchema = Yup.object().shape({
  name: Yup.string().min(11).max(80),
  nationalId: Yup.string().matches(
    /^[0-9]{14}$/,
    "Please enter valid National Id consists of 14 numbers",
  ),
  residence: Yup.string().required(),
  email: Yup.string().matches(
    /^[a-zA-Z0-9.!#$%&'*+=?^_]{3,25}@(?:[a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{3,25}$/,
    `Please enter valid email:
          Username must be between 3 and 25 characters.
          Username can only contain letters, numbers, and special characters.
          Domain name must be between 1 and 63 characters.
          Domain name extension must be .text between 3 and 25 characters.
        `,
  ),
  workPostalNumber: Yup.string()
    .matches(/^[0-9]*$/, "postal code must be digits")
    .max(5, "postal code must be at most 5 characters")
    .min(2, "postal code must be at least 2 characters"),
  phoneNumber: Yup.string().matches(/^[0-9]*$/).max(15).min(7),
  workPhone: Yup.string().matches(/^[0-9]*$/).max(15).min(7),
  workAddress: Yup.string().required(),
  jobTitle: Yup.string().required(),
  jobRanking: Yup.string().required(),
  workNature: Yup.string().required(),
  currentWorkDuration: Yup.string().required(),
  academicQualification: Yup.string().required(),
  academicSpecialization: Yup.string().required(),
  qualificationSource: Yup.string().required(),
  qualificationYear: Yup.string().required(),
  otherQualifications: Yup.string().required(),
  lastTrainingPrograms: Yup.string().required(),
  trainerName: Yup.string().required(),
  trainerJobTitle: Yup.string().required(),
  trainerPhone: Yup.string().matches(/^[0-9]*$/).max(15).min(7),
  trainerFax: Yup.string().required(),
  trainerEmail: Yup.string().matches(
    /^[a-zA-Z0-9.!#$%&'*+/=?^_]{3,25}(@[a-zA-Z0-9]{3,25}\.[a-zA-Z]{3,25})$/,
    `Please enter valid email:
          Username must be between 3 and 25 characters.
          Username can only contain letters, numbers, and special characters.
          Domain name must be between 3 and 25 characters.
          Domain name extension must be .text between 3 and 25 characters.
        `,
  ),
});
